var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-cell-renderer-actions',{attrs:{"actions":_vm.filteredActionsFromParent},on:{"view":function($event){return _vm.viewRecord()},"clone":function($event){return _vm.cloneRecord()},"edit":function($event){return _vm.editRecord()},"delete":function($event){return _vm.confirmDeleteRecord()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }